module.exports = __webpack_public_path__ + "static/bg.3e0c7eac.png";